import UnauthorizedError from '../../../core/domain/User/errors/UnauthorizedError';
import StorageAbstractFactory from '@infrastructure/cache';
import _ from 'lodash';

/**
 * Decorate the instance adding and interceptor
 *
 * @param {import('axios').AxiosInstance} instance
 * @returns {import('axios').AxiosInstance}
 *
 * @author Jose Aburto <pino0071@gmail.com>
 */
export default function AttachTokenInterceptor(instance) {
  const onFulfilled = request => {
    request.headers['Authorization'] = 'Bearer ' + StorageAbstractFactory.getSyncGlobalInstance().getItem('token');
    request.headers['Content-Type'] = _.get(request, "headers['Content-Type']", 'application/json');
    return request;
  };

  const onRejected = () => Promise.reject(new UnauthorizedError());

  instance.interceptors.request.use(onFulfilled, onRejected);
  return instance;
}
